goog.provide("shadow.js.shim.module$dayjs$locale$lv");
goog.provide("module$shadow_js_shim_module$dayjs$locale$lv");
shadow.js.shim.module$dayjs$locale$lv = shadow.js.nativeProvides["dayjs/locale/lv"] = require("dayjs/locale/lv");
module$shadow_js_shim_module$dayjs$locale$lv.default = shadow.js.shim.module$dayjs$locale$lv;
